import { defineComponent as _defineComponent } from 'vue'
import { LotStatus } from "@/enums/LotStatus";
  import { getLotStatusClass } from "@/helpers/status";
  import { computed } from "vue";
  import { formatDate } from "@/helpers/date";
  import { formatPrice as formatNumbers } from "@/helpers/transformation/price";
  import { LotInterface } from "@/types/LotInterface";
  import { StageInterface } from "@/types/StageInterface";
  import { InitialHoldInterface } from "@/types/InitialHoldInterface";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'InitialHoldLotDetailsCard',
  props: {
    lot: {},
    stage: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const lot = computed(() => props.lot);
  const lotStatusText = computed(() => {
    return lot.value?.status === LotStatus.EOI
      ? LotStatus.PRE_CONTRACT
      : lot.value?.status;
  });

  const getLotStatusStyle = (status: LotStatus) =>
    getLotStatusClass(
      status === LotStatus.EOI ? LotStatus.PRE_CONTRACT : status
    );

  function zeroCheck(value: string, units: string) {
    return +value ? `${value} ${units}` : "Irregular";
  }

const __returned__ = { props, lot, lotStatusText, getLotStatusStyle, zeroCheck, get LotStatus() { return LotStatus }, get getLotStatusClass() { return getLotStatusClass }, computed, get formatDate() { return formatDate }, get formatNumbers() { return formatNumbers }, get LotInterface() { return LotInterface }, get StageInterface() { return StageInterface }, get InitialHoldInterface() { return InitialHoldInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})